export function getCalendarGridAgendaDays({ days, itemsByDay }) {
  return days.filter(day => itemsByDay[day.date]?.length > 0)
}

// A failed read keeps the previous items, so the error takes their place
export function getIsCalendarGridAgendaListShown({ agendaDays, loadError }) {
  return agendaDays.length > 0 && !loadError
}

export function getCalendarGridAgendaMessage({ message, t }) {
  return message ?? { text: t('Calendar.EmptyAgendaKey') }
}
